import React from 'react'
import '../Projects/Projects.css'
import { Link } from 'react-router-dom'
import defaultProject from '../../assets/default-project.jpeg'
import twinpacs from '../../assets/twinpacs.png'
import lcexten from '../../assets/lcexten.png'
import moiveApp from '../../assets/movie-app.png'
import cpunified from '../../assets/cpunified.png'
import oldPortfolio from '../../assets/old-portfolio.png'
import codechefViit from '../../assets/codechef-Viit.png'
// import loveCal from '../../assets/love-cal.png'

function Projects() {

    const projects = [
        {
            hyperLink: "https://github.com/akashh369/twinpacs",
            link: "true",
            heading: "Twinpacs landing page",
            description: "Developed a responsive landing page for Twinpacs, a company specializing in IT solutions. Collaborated with the client to design and implement an engaging, user-friendly website that effectively communicates Twinpacs’ expertise and services in the technology sector.",
            keywords: ["Angular", "Tailwind", "Nodejs"],
            img: twinpacs
        },
        {
            hyperLink: "https://github.com/akashh369/Codechef-API",
            link: "true",
            heading: "CPUnified",
            description: "Developed a web application to track and compare user statistics across multiple coding platforms, with a focus on CodeChef. Implemented real-time data scraping using Puppeteer to collect contest results and aggregate performance metrics, enabling users to visualize and benchmark their coding progress efficiently",
            keywords: ["React", "Express", "Puppeteer", "MongoDB"],
            img: cpunified
        },
        {
            hyperLink: "https://github.com/akashh369/lcexten",
            link: "true",
            heading: "LeetCode Extension",
            description: "Motivated by my own hesitation around difficulty labels, I created a browser extension that hides difficulty tags on LeetCode problems, enabling users to approach each challenge with an open mind.",
            keywords: ["Javascript"],
            img: lcexten
        },
        {
            hyperLink: "https://github.com/akashh369/reactmovieapp",
            link: "true",
            heading: "Movie App",
            description: "A movie web app that allows users to view top trending movies and web series, search for any movie, and watch its trailer",
            keywords: ["Reactjs"],
            img: moiveApp
        },
        {
            hyperLink: "https://github.com/akashh369/viit-codechef-22-23",
            link: "true",
            heading: "Viit Codechef landing page",
            description: "A movie web app that allows users to view top trending movies and web series, search for any movie, and watch its trailer",
            keywords: ["Reactjs"],
            img: codechefViit
        },
        {
            hyperLink: "https://github.com/akashh369/reactportfolio",
            link: "true",
            heading: "Old Portfolio",
            description: "A movie web app that allows users to view top trending movies and web series, search for any movie, and watch its trailer",
            keywords: ["Reactjs"],
            img: oldPortfolio
        }
    ]


    return (
        <div className="projects-all" >
            <span className='project-title'>Projects</span>
            <div className='projects-all-2'>
                {
                    projects.map((item, i) => {
                        return (
                            <Link to={item.hyperLink} key={i}>
                                <div className='project-card'>
                                    <div className="project-img">
                                        <img src={item.img ?? defaultProject} />
                                    </div>
                                    <div className="project-name">
                                        <span>{item.heading}</span>
                                    </div>
                                </div>
                            </Link>
                        )
                    })

                }
            </div>
        </div>
    )
}

export default Projects
